import { gql } from "@apollo/client";

const CEWP_USER_DISTRICT_FIELDS = `
  _id
  code
  name
`;

const CEWP_USER_LIST_FIELDS = `
  _id
  code
  firstName
  lastName
  phoneNumber
  emailAddress
  certificationNumber
  status
  profileImageUrl
  districts {
    ${CEWP_USER_DISTRICT_FIELDS}
  }
  createdAt
  updatedAt
  suspendedAt
  deletedAt
`;

export const GET_CEWP_USERS = gql`
  query GetCEWPUsers(
    $page: Int
    $pageSize: Int
    $sort: String
    $search: String
    $searchFields: [String!]
    $district: ID
    $status: UserStatus
    $allowDisabledUsers: Boolean
  ) {
    rows: getCEWPUsers(
      page: $page
      pageSize: $pageSize
      sort: $sort
      search: $search
      searchFields: $searchFields
      district: $district
      status: $status
      allowDisabledUsers: $allowDisabledUsers
    ) {
      ${CEWP_USER_LIST_FIELDS}
    }
    count: getCEWPUsersCount(
      search: $search
      searchFields: $searchFields
      district: $district
      status: $status
      allowDisabledUsers: $allowDisabledUsers
    )
  }
`;

export const GET_CEWP_USERS_SUMMARY = gql`
  query GetCEWPUsersSummary(
    $search: String
    $searchFields: [String!]
    $sort: String
    $district: ID
    $status: UserStatus
    $allowDisabledUsers: Boolean
  ) {
    summary: getCEWPUsersSummary(
      search: $search
      searchFields: $searchFields
      sort: $sort
      district: $district
      status: $status
      allowDisabledUsers: $allowDisabledUsers
    ) {
      Active
      Suspended
      Deleted
    }
  }
`;

export const GET_CEWP_USER = gql`
  query GetCEWPUser($id: ID!) {
    user: getCEWPUser(id: $id) {
      _id
      code
      firstName
      lastName
      phoneNumber
      emailAddress
      certificationNumber
      status
      profileImageUrl
      districts {
        ${CEWP_USER_DISTRICT_FIELDS}
      }
      partner {
        _id
        code
        name
      }
      createdAt
      updatedAt
      suspendedAt
      deletedAt
    }
  }
`;

export const CREATE_CEWP_USER = gql`
  mutation CreateCEWPUser(
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
    $emailAddress: String!
    $certificationNumber: String!
    $profileImageUrl: String
    $districts: [ID!]!
  ) {
    createCEWPUser(
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      emailAddress: $emailAddress
      certificationNumber: $certificationNumber
      profileImageUrl: $profileImageUrl
      districts: $districts
    ) {
      _id
    }
  }
`;

export const UPDATE_CEWP_USER = gql`
  mutation UpdateCEWPUser(
    $id: ID!
    $firstName: String
    $lastName: String
    $phoneNumber: String
    $emailAddress: String
    $certificationNumber: String
    $profileImageUrl: String
    $districts: [ID!]
  ) {
    updateCEWPUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      emailAddress: $emailAddress
      certificationNumber: $certificationNumber
      profileImageUrl: $profileImageUrl
      districts: $districts
    ) {
      _id
    }
  }
`;

export const SUSPEND_CEWP_USER = gql`
  mutation SuspendCEWPUser($id: ID!) {
    suspendCEWPUser(id: $id) {
      _id
    }
  }
`;

export const RESTORE_CEWP_USER = gql`
  mutation RestoreCEWPUser($id: ID!) {
    restoreCEWPUser(id: $id) {
      _id
    }
  }
`;

export const DELETE_CEWP_USER = gql`
  mutation DeleteCEWPUser($id: ID!) {
    deleteCEWPUser(id: $id) {
      _id
    }
  }
`;
